import { createRouter, createRootRoute } from "@tanstack/react-router";
import { RootLayout } from "./__root";
import { createPublicRoutes } from "./publicRoutes";
import { createAdminRoutes } from "./adminRoutes";
import { createManagerRoutes } from "./managerRoutes";
import { createProtectedRoutes } from "./protectedRoutes";
import NotFound from "@/features/error/notFound";

// Root route
const rootRoute = createRootRoute({ component: RootLayout });

// Assemble route tree from split modules
const routeTree = rootRoute.addChildren([
  ...createPublicRoutes(rootRoute),
  ...createProtectedRoutes(rootRoute),
  createAdminRoutes(rootRoute),
  createManagerRoutes(rootRoute),
]);

// Router
export const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error }) => {
    if (
      typeof error?.message === "string" &&
      error.message.startsWith("__redirect:")
    ) {
      window.location.href = error.message.replace("__redirect:", "");
      return null;
    }
    return <div>Error: {error?.message}</div>;
  },
  defaultNotFoundComponent: () => <NotFound />,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  interface StaticDataRouteOption {
    layout?: "auth" | "admin" | "app" | "fullpage";
  }
}
